import C from "@/utils/constants";

export default [
  {
    path: "qa-review",
    component: () => import("@/views/console/QAReview"),
    meta: {
      roles: [C.ROLE.ADMIN, C.ROLE.QA_TEAM],
    },
    children: [
      {
        path: "",
        name: "qa-review",
        component: () => import("@/components/console/qa-review/QAReviewList"),
        meta: {
          roles: [C.ROLE.ADMIN, C.ROLE.QA_TEAM],
        },
      },
      { path: "opportunity", redirect: "/console/qa-review" },
      {
        path: "opportunity/:id",
        name: "qa-review-opportunity",
        components: {
          default: () => import("@/components/console/qa-review/QAReviewList"),
          view: () =>
            import("@/components/console/opportunities/OpportunityDetail"),
        },
        props: {
          view: (route) => {
            return {
              mode: "view",
              opportunityId: route.params.id,
            };
          },
        },
        meta: {
          roles: [C.ROLE.ADMIN, C.ROLE.QA_TEAM],
        },
      },
    ],
  },
];
